import { useState } from 'react';
import type { PlayerBadgeDto } from '@rw/shared';
import { BadgeMedal } from './BadgeMedal';
import { BadgeSheet } from './BadgeSheet';
import { badgeName, badgeValue } from './achievements';

/** All badges: earned ones in colour, locked ones grey with their progress towards the next tier. */
export function BadgeGrid({ badges, isMe }: { badges: PlayerBadgeDto[]; isMe: boolean }) {
  const [open, setOpen] = useState<PlayerBadgeDto | null>(null);
  return (
    <>
      <div className="grid grid-cols-3 gap-3" data-testid="badge-grid">
        {badges.map((b) => {
          const next = b.thresholds[b.tier];
          return (
            <button
              key={b.id}
              onClick={() => setOpen(b)}
              className="flex flex-col items-center rounded-2xl bg-ink-850 px-1 py-3 active:opacity-80"
              data-testid={`badge-${b.id}`}
              data-tier={b.tier}
            >
              <BadgeMedal id={b.id} tier={b.tier} size={56} />
              <span
                className={`mt-1 text-center text-xs font-semibold leading-tight ${b.tier ? '' : 'text-ink-400'}`}
              >
                {badgeName(b.id)}
              </span>
              <span className="mt-0.5 text-[11px] text-ink-500 tabular">
                {next !== undefined
                  ? `${badgeValue(b.id, Math.min(b.progress, next))} / ${badgeValue(b.id, next)}`
                  : '✓'}
              </span>
            </button>
          );
        })}
      </div>
      <BadgeSheet badge={open} onClose={() => setOpen(null)} isMe={isMe} />
    </>
  );
}
